import { ConfigProvider, Flex, Loading } from '@/components';
import type { FC, PropsWithChildren } from 'react';

type Props = {
  isLoading: boolean;
  width: string;
};

export const LedgerPage: FC<PropsWithChildren<Props>> = ({
  children,
  isLoading,
  width,
}) => {
  return (
    <ConfigProvider theme={{ token: { borderRadiusLG: 0 } }}>
      <Flex
        vertical
        style={{
          width,
          printColorAdjust: 'exact',
          WebkitPrintColorAdjust: 'exact',
        }}
      >
        {isLoading ? <Loading /> : children}
      </Flex>
    </ConfigProvider>
  );
};
